import * as SCHEMA from "@/api/schema";

const state = {
  SchemaList:  [],
  CONTACT_ID: JSON.parse(localStorage.getItem("CONTACT_ID")) || "",
  ACCOUNT_ID: JSON.parse(localStorage.getItem("ACCOUNT_ID")) || "",
  CustomTypeList: [],
  CustomList: [],
  // Sheets keeps its profile-scoped copy of the same columns here so its loads
  // never write into the CustomList the sequence editors read.
  SheetsColumns: [],
  SheetsColumnsProfileId: null,
  SheetsColumnsRequestId: 0,
  crm_columns_list_map: {},
};
const mutations = {
  setCRMSchemaList(state, data) {
    state.SchemaList = data;
    data?.forEach((item) => {
      if (item.slug === "contact") {
        state.CONTACT_ID = item.crm_schema_id;
        localStorage.setItem("CONTACT_ID", JSON.stringify(item.crm_schema_id));
      } else if (item.slug === "account") {
        state.ACCOUNT_ID = item.crm_schema_id;
        localStorage.setItem("ACCOUNT_ID", JSON.stringify(item.crm_schema_id));
      }
    });
  },
  setCustomTypeList(state, data) {
    state.CustomTypeList = data;
  },
  setCustomList(state, data) {
    data && (state.CustomList = data);
  },
  setSheetsColumns(state, { profile_id, columns }) {
    state.SheetsColumns = columns;
    state.SheetsColumnsProfileId = profile_id;
  },
  set_sheets_columns_request_id(state, id) {
    state.SheetsColumnsRequestId = id;
  },
  clearSheetsColumns(state) {
    state.SheetsColumns = [];
    state.SheetsColumnsProfileId = null;
  },
  set_crm_columns_list_map(state, data) {
    state.crm_columns_list_map = data;
  },
};
const actions = {
  async getCRMSchemaList(context) {
    try {
      const id = this.state.user.currentId.profile_id;
      const res = await SCHEMA.getCRMSchemaList({ profile_id: id });
      context.commit("setCRMSchemaList", res?.data);
      return res?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getCustomTypeList(context, data) {
    try {
      const res = await SCHEMA.getCustomTypeList(data);
      context.commit("setCustomTypeList", res?.data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getCustomList(context, options = {}) {
    try {
      // Passing `profile_id` opts into profile-scoped, stale-guarded loading
      // that lands in SheetsColumns (currently Sheets only). Callers that omit
      // it keep the original behaviour and the original CustomList target.
      const scoped_profile_id = options.profile_id || null;
      if (!scoped_profile_id) {
        const res = await SCHEMA.getCRMColumns({
          profile_id: this.state.user.currentId.profile_id,
          is_full_page_search: true,
          // "crm_schema_id": this.state.schema.CONTACT_ID
        });
        context.commit("setCustomList", res?.data?.crm_schema_columns);
        return;
      }
      const request_id = (context.state.SheetsColumnsRequestId || 0) + 1;
      context.commit("set_sheets_columns_request_id", request_id);
      const res = await SCHEMA.getCRMColumns({
        profile_id: scoped_profile_id,
        is_full_page_search: true,
      });
      if (
        this.state.user.currentId.profile_id !== scoped_profile_id ||
        context.state.SheetsColumnsRequestId !== request_id
      ) {
        return null;
      }
      const columns = res?.data?.crm_schema_columns || [];
      context.commit("setSheetsColumns", {
        profile_id: scoped_profile_id,
        columns,
      });
      return columns;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async createCustomList(context, data) {
    try {
      const id = this.state.user.currentId.profile_id;
      const unused_res = await SCHEMA.createCRMColumn({ profile_id: id, ...data });
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async updateCustomList(context, data) {
    try {
      const id = this.state.user.currentId.profile_id;
      const unused_res = await SCHEMA.updateCRMColumn({ profile_id: id, ...data });
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async deleteCRMColumn(context, data) {
    try {
      const id = this.state.user.currentId.profile_id;
      const unused_res = await SCHEMA.deleteCRMColumn({ profile_id: id, ...data });
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
